export enum Status {
  isSavedAsDraft,
  isDrafted,
  isSubmitted,
  isBUApproved,
  isSBUApproved,
  isSBGApproved,
  isCSGOApproved,
  isRejected,
  isOnHold

}

export interface PostProjectStatusModel {
  status: Status;
  projectId: number;
  approverUserId: number;
  approverRoleId: number;
  comments?: string;
}
